import * as React from "react";
import { useState } from "react";
import { Box, Typography, Divider, useMediaQuery } from "@mui/material";
import { ImageTile } from "./ImageTile";


let profileInfo = require("../artistProfileInfo.js");
let artistsData = profileInfo.getArtistProfileData();
let artists = Object.keys(artistsData);

function renderImageTiles(exitPage, setExitPage) {
    return artists.map((artist, index) => (
        <ImageTile
            artist={artist}
            artistInfo={artistsData[artist]}
            index={index}
            exitPage={exitPage}
            setExitPage={setExitPage}
            exitAnimationDelay={0}
            exitAnimationDuration={0}
            exitDelay={0}
            key={index}
            mobile={true}
        />
    ));
}

function ArtistsMobile() {
    let [exitPage, setExitPage] = useState(false);
    const landscapeOrientation = useMediaQuery('(orientation:landscape)');

    return (
        <Box
            role="navigation"
            aria-label="Select an artist to learn more about them."
            sx={{
                width: landscapeOrientation ? "90vw" : "100vw",
                minWidth: "270px",
                margin: "0 auto",
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "primary.main",
                    columns: "1 / span 2",
                    paddingLeft: "2.6%",
                    paddingRight: "2.6%",
                }}
            >
                <Typography
                    component="h2"
                    sx={{
                        fontFamily: "WindsorD-Bol",
                        fontSize: "40px",
                        lineHeight: "56px",
                        letterSpacing: "0.8pt",
                        color: "text.primary",
                        marginTop: "25px",
                        textAlign: "center"
                    }}
                >
                    We. The Culture:
                </Typography>
                <Typography
                    sx={{
                        fontSize: "15px",
                        lineHeight: "20px",
                        letterSpacing: "2.16pt",
                        textTransform: "uppercase",
                        marginBottom: "10px",
                        color: "text.primary",
                        textAlign: "center",
                    }}
                >
                    Works By the Eighteen Art Collective
                </Typography>
                <Divider
                    sx={{
                        borderColor: "text.primary",
                        borderWidth: "1px",
                        width: "90%",
                    }}
                />
                <Typography
                    component="h1"
                    sx={{
                        fontFamily: "WindsorD-Bol",
                        fontSize: "72px",
                        lineHeight: "76px",
                        letterSpacing: "1.48pt",
                        color: "text.primary",
                        textAlign: "center",
                        width: "90.65vw",
                        marginTop: "20px"
                    }}
                >
                    Meet the Artists
                </Typography>
                <Typography
                    sx={{
                        fontSize: "18px",
                        lineHeight: "21px",
                        letterSpacing: "0.36pt",
                        color: "text.primary",
                        textAlign: "center",
                        margin: "25px 0px 25px 0px"
                    }}
                >
                    Tap on a photo to learn more about the artist
                </Typography>
            </Box>
            <Box
                sx={{
                    width: landscapeOrientation ? "90vw" : "100vw",
                    display:"grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gripTemplateRows: "repeat(9, 1fr)",
                    columnGap: "2.33vw",
                    rowGap: "30px",
                    paddingLeft: "4.736vw",
                    paddingRight: "4.736vw",
                    paddingTop: "35px"
                }}
            >
                {renderImageTiles(exitPage, setExitPage)}
            </Box>
        </Box>

    )
}

export default ArtistsMobile;
